var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconEletric = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.7261 37.226C13.7261 38.0313 14.1775 38.6331 14.5812 38.6331H33.4186C33.8223 38.6331 34.2737 38.0313 34.2737 37.226V28.5963H13.7261V37.226ZM22.5929 32.5196H25.4069V35.3337H22.5929V32.5196Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.54 18.6783H19.3541V25.7822H16.54V18.6783Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9999 0L0.0639648 19.6231L1.84807 21.7993L3.34824 20.5694V48H19.7789V41.4471H14.5813C12.5582 41.4471 10.9121 39.5535 10.9121 37.226V25.7822H13.7262V15.8642H22.1683V25.7822H25.8317V15.8642H34.2739V25.7822H37.0879V37.226C37.0879 39.5535 35.4419 41.4471 33.4188 41.4471H28.2212V48H44.6364V20.5568L46.152 21.7993L47.9361 19.6231L23.9999 0Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5928 41.4471H25.4068V48H22.5928V41.4471Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.646 18.6783H31.46V25.7822H28.646V18.6783Z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEletric, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_eletric.a23ca61e.svg";
export { ForwardRef as ReactComponent };